module.exports = __webpack_public_path__ + "img/lucia.9f3d45df.png";